// THE FLEET OVERVIEW'S VIEW REGISTRY (spec 15 §4 S3; D-625).
//
// The server decides WHICH tiles and attention rows a staff member sees: each
// comes from a source registered in apps/api/src/modules/platform-console/
// fleet/fleet-sources.registry.ts, and a store that does not exist has no
// source and so no tile. This file decides only how a known key LOOKS: its
// label and where clicking it goes.
//
// TO ADD A TILE OR AN ATTENTION KIND (another M15 lane, append-only): add an
// entry below with its i18n keys in all six admin catalogues
// (admin.fleet.tiles.<key>, admin.fleet.attention.<kind>). A key the server
// sends that this bundle does not know yet (the API and the web deploy apart)
// still renders, labelled with the raw key, so a number is never hidden.

export interface FleetLink {
  /** A console path from console-routes.tsx. */
  readonly to: string;
  readonly search?: Readonly<Record<string, string>>;
}

export interface FleetTileView {
  readonly labelKey: string;
  readonly link?: FleetLink;
}

export interface FleetAttentionView {
  readonly labelKey: string;
  /** Where the operator acts on the tenant; absent opens the tenant (S5). */
  readonly link?: (tenantId: string) => FleetLink;
}

export const FLEET_TILE_VIEWS: Readonly<Record<string, FleetTileView>> = {
  tenants_active: {
    labelKey: "admin.fleet.tiles.tenants_active",
    link: { to: "/console/tenants", search: { status: "active" } },
  },
  tenants_provisioning: {
    labelKey: "admin.fleet.tiles.tenants_provisioning",
    link: { to: "/console/tenants", search: { status: "provisioning" } },
  },
  tenants_suspended: {
    labelKey: "admin.fleet.tiles.tenants_suspended",
    link: { to: "/console/tenants", search: { status: "suspended" } },
  },
  tenants_provision_failed: {
    labelKey: "admin.fleet.tiles.tenants_provision_failed",
    link: { to: "/console/tenants", search: { status: "provision_failed" } },
  },
  staff_signed_in: {
    labelKey: "admin.fleet.tiles.staff_signed_in",
  },
  // ---- other lanes append their tile views above this line ----
};

export const FLEET_ATTENTION_VIEWS: Readonly<Record<string, FleetAttentionView>> = {
  provision_failed: { labelKey: "admin.fleet.attention.provision_failed" },
  provisioning_stalled: { labelKey: "admin.fleet.attention.provisioning_stalled" },
  // ---- other lanes append their attention views above this line ----
};
